export enum TravelMode {
    DRIVING = <any>'driving',
    WALKING = <any>'walking',
    BICYCLING = <any>'bicycling'
}


// WEBPACK FOOTER //
// /Users/cwseger/go/src/github.com/cwseger/travel-time-ui/src/app/enums/travel-mode.enum.ts